'use client';

import React from 'react';
import HeroSection from './HeroSection';
import FounderStory from './FounderStory';
import PhilosophySection from './PhilosophySection';
import CoachTeam from './CoachTeam';
import TimelineSection from './TimelineSection';
import CTASection from './CTASection';

const AboutInteractive = () => {
  return (
    <>
      <HeroSection />
      <FounderStory />
      <PhilosophySection />
      <CoachTeam />
      <TimelineSection />
      <CTASection />
    </>
  );
};

export default AboutInteractive;